export const GET_CONTENT_PRIVATE_DATA = 'GET_CONTENT_PRIVATE_DATA';
export const GET_CONTENT_PRIVATE_DATA_SUCCESS = 'GET_CONTENT_PRIVATE_DATA_SUCCESS'

export function getPageContent() {
  return {
    type: GET_CONTENT_PRIVATE_DATA,
    pageType: 'privateData'
  }
}

export function getPageContentSuccess(content) {
  return {
    type: GET_CONTENT_PRIVATE_DATA_SUCCESS,
    content
  }
}